module.exports = __webpack_public_path__ + "static/media/edly-login-illustration.f0674593.svg";